






import { Component, Vue } from 'vue-property-decorator';
import ConfigModlue from '@/store/modules/config';

@Component
export default class ExInformation extends Vue {
  // 現在の鉄道運行情報画像
  private url = '';

  // 鉄道運行情報画像
  private items: string[] = [];

  // インターバル間隔（秒）
  private interval: number | null = null;

  // 現在の表示インデックス
  private index?: number;

  // タイマーID
  private timerID?: number;

  // 再読み込みタイマーID
  private reloadTimerID?: number;

  // ストアアクションの購読解除関数
  private unsubscribe?: Function;

  /**
   * 鉄道運行情報画像を取得
   */
  get currentImages(): string[] {
    return this.items;
  }

  activated() {
    this.unsubscribe = this.$store.subscribe(mutation => {
      // 管理画面より設定の更新があった場合、API読み込みを再開
      if (mutation.type === 'config/setDatas') {
        const routename = ConfigModlue.routename;
        if (this.$route.name === routename) {
          this.load();
        }
      }
    });

    // 外部情報API読み込み
    this.load();
  }

  deactivated() {
    this.unsubscribe && this.unsubscribe();
    this.timerID && window.clearTimeout(this.timerID);
    this.reloadTimerID && window.clearTimeout(this.reloadTimerID);
  }

  /**
   * 外部情報API読み込み
   */
  private load() {
    this.timerID && window.clearTimeout(this.timerID);
    this.reloadTimerID && window.clearTimeout(this.reloadTimerID);
    const timestamp = new Date().getTime();
    const uri = `${process.env.VUE_APP_API_DOMAIN}/api/information?${timestamp}`;
    this.axios.get(uri).then(response => {
      this.items = response.data.items;
      this.interval = response.data.interval || 1;
      const reloadInterval = response.data.reload || null;

      // キャッシュを更新
      this.items = this.items.map(item => item + '?' + new Date().getTime());

      // インターバル開始
      this.next();

      if (reloadInterval !== null && reloadInterval > 0) {
        // 数分後に再読み込み
        this.reloadTimerID = window.setTimeout(this.load.bind(this), reloadInterval * 60 * 1000);
      }
    });
  }

  /**
   * 次の画像を表示する
   */
  private next() {
    if (this.index != undefined) {
      this.index++;
      if (this.index > this.items.length - 1) {
        this.index = 0;
      }
    } else {
      this.index = 0;
    }
    this.url = this.items[this.index];
    this.timerID && window.clearTimeout(this.timerID);
    if (this.interval !== null && this.interval > 0) {
      this.timerID = window.setTimeout(this.next.bind(this), this.interval * 1000);
    }
  }
}
